import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClapboardSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconClapboardSparkle"><Path d="M20.5 12V3.5H3.5V20.5H12" stroke="currentColor"/><Path d="M3.5 8.5H20.5" stroke="currentColor"/><Path d="M8.25 8.5L10.25 3.5" stroke="currentColor"/><Path d="M13.75 8.5L15.75 3.5" stroke="currentColor"/><Path d="M18.4 14H17.6L16.6 16.6L14 17.6V18.4L16.6 19.4L17.6 22H18.4L19.4 19.4L22 18.4V17.6L19.4 16.6L18.4 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClapboardSparkle;
